import { notification } from 'antd';
import NotificationWrapper, { INotification } from 'components/atoms/NotificationComponent';
import React, { createContext, Dispatch, SetStateAction, useState } from 'react';
// Sem vkladat jednotlive casti store, napr. token, language, nactena data z API ktera budou globalni pro vsechny
export interface IStore {
    token: string | null;
    tokenURL: string;
    language: 'cz' | 'en';
    prevPath: string; // Zde si mohu ulozit url z ktere prichazim na novou stranku
    dashboardWrapperTopSelected: IDashboardWrapperTopSelected | null;
    NotificationComponent: (props: INotification) => void;
}
export interface IDashboardWrapperTopSelected {
    name: string[];
}

// Dipsatcher pro store, dle zadani bude upravovan
interface IStoreActions {
    setStoreState?: Dispatch<SetStateAction<IStore>>;
}

export type IStoreKeys = keyof IStore;

// defaultni hodnota globalniho store, prozatim {}
const defaultStoreState: IStore = {
    token: null,
    tokenURL: '',
    language: 'cz',
    prevPath: '',
    dashboardWrapperTopSelected: null,
    NotificationComponent: () => {}
};

// globalni store
export const Context = createContext<IStore & IStoreActions>(defaultStoreState);

// Zakladni komponenta se store, ktera nam dovoluje pouzivat v jejich childech useContext
const Store: React.FC = ({ children }) => {
    const [storeState, setStoreState] = useState<IStore>(defaultStoreState);
    // notification component musime declarovat tu aby mal pristup ku current state (Robilo neplechu pri zmene jazyka)
    const [api, contextHolder] = notification.useNotification();
    const NotificationComponent = NotificationWrapper(api);

    return (
        <Context.Provider
            value={{
                ...storeState,
                NotificationComponent,
                setStoreState
            }}
        >
            {contextHolder}
            {children}
        </Context.Provider>
    );
};

export default Store;
